export enum NipStatus {
  Blank = 1,
  Assigned = 2,
  Revoked = 3,
  Canceled = 4,
}
